export const SET_FILTERS = 'setFilters';
export const SET_PAGINATION_DATA = 'setPaginationData';
export const SET_SEARCH_TERM = 'setSearchTerm';
export const RESET_PAGINATION = 'resetPagination';
